<template>
  <b-modal
      ref="self"
      class="card-form-modal"
      :active="active"
      :custom-class="'dialog mpc'"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      scroll="clip"
      @close="cancel">
    <template>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ material ? 'Edit' : 'Add' }} material</p>
            <button class="modal-close is-large active" aria-label="close" @click="cancel"></button>
          </header>
          <section class="modal-card-body">
            <form>
              <b-field label="Category*"
                       :type="{ 'is-danger': invalidFields.categoryId }"
                       :message="invalidFields.categoryId">
                <b-select placeholder="Select a category" v-model="selectedCategory">
                  <option v-for="category in categories" :value="category" :key="category.id">
                    {{ category.name }}
                  </option>
                </b-select>
              </b-field>

              <b-field label="Title*"
                       :type="{ 'is-danger': invalidFields.name }"
                       :message="invalidFields.name">
                <b-input rules="max:100" v-model="name" type="text" maxlength="255"></b-input>
              </b-field>

              <b-field v-if="isTextContentCategoryType"
                       label="Content*"
                       :type="{ 'is-danger': invalidFields.content }"
                       :message="invalidFields.content">
                <b-input v-model="content" type="textarea"></b-input>
              </b-field>

              <template v-if="isVideoContentCategoryType">
                <b-field label="Video type*"
                         :type="{ 'is-danger': invalidFields.videoType }"
                         :message="invalidFields.videoType">
                  <b-select placeholder="Select a type" v-model="videoType">
                    <option v-for="type in MATERIAL_VIDEO_TYPES" :value="type" :key="type">
                      {{ type }}
                    </option>
                  </b-select>
                </b-field>

                <b-field v-if="isVideoYouTubeType"
                         label="YouTube Video Id*"
                         :type="{ 'is-danger': invalidFields.videoId }"
                         :message="invalidFields.videoId">
                  <b-input v-model="videoId"></b-input>
                </b-field>

                <b-field v-if="isVideoMP4Type"
                         rules="url_regexp"
                         label="Video*"
                         :type="{ 'is-danger': invalidFields.videoSrc }"
                         :message="invalidFields.videoSrc">
                  <b-input v-model="videoSrc"></b-input>
                </b-field>

                <template v-if="isVideoMP4Type">
                  <b-field label="Video image*"
                           :type="{ 'is-danger': invalidFields.videoImgFile }"
                           :message="invalidFields.videoImgFile">
                    <div>
                      <img :src="currentImageSrc" width="50"/>
                      <b-field
                          class="file is-primary"
                          :class="{'has-name': !!videoImgFile}">
                        <b-upload v-model="videoImgFile" class="file-label">
                      <span class="file-cta">
                          <b-icon class="file-icon" icon="upload"></b-icon>
                          <span class="file-label">Click to upload</span>
                      </span>
                          <span class="file-name" v-if="videoImgFile">
                        {{ videoImgFile.name }}
                    </span>
                        </b-upload>
                      </b-field>
                    </div>
                  </b-field>
                </template>


                <template v-if="isVideoContentCategoryType">
                  <b-field label="Video Duration*"
                           :type="{ 'is-danger': invalidFields.videoDuration }"
                           :message="invalidFields.videoDuration">
                    <div style="display: flex; align-items: center">
                      <b-input style="width:100px"
                          @input="onVideoDurationInput" ref="videoDurationInput"></b-input>
                      <span style="color:gray;margin-left:10px;">min.</span>
                    </div>
                  </b-field>
                </template>

                <b-field v-if="isVideoContentCategoryType"
                         label="Date"
                         :type="{ 'is-danger': invalidFields.date }"
                         :message="invalidFields.date">
                  <b-input @click.native="showDatetimepicker"
                           :value="date ? date.toLocaleString('en-GB').slice(0, -3) : null"
                           placeholder="Click to select a date"
                           type="text"
                           readonly
                           class="datetime-input__input" />
                </b-field>
              </template>

              <b-field label="Order"
                       :type="{ 'is-danger': invalidFields.order }"
                       :message="invalidFields.order">
                <b-input
                    maxlength="3"
                    style="width:110px" @input="onOrderInput" ref="orderInput"></b-input>
              </b-field>
            </form>

          </section>
          <footer class="modal-card-foot buttons is-right">
            <button class="button" type="button" @click="cancel">Cancel</button>
            <button type="submit" class="button is-success" @click="submit">
              {{ material ? 'Update' : 'Add' }}
            </button>
          </footer>
        </div>
    </template>
  </b-modal>
</template>

<script>

import {
  CATEGORIES_CONTENT_TYPE_TEXT,
  CATEGORIES_CONTENT_TYPE_VIDEO, MATERIAL_VIDEO_TYPE_MP4,
  MATERIAL_VIDEO_TYPE_YOUTUBE,
  MATERIAL_VIDEO_TYPES,
} from '@/views/TrainingAndFaqs.vue';
import Vue from 'vue';
import DatetimepickerModal from '@/components/Modal/Datetimepicker.vue';

export default {
  name: 'SettingsMaterial',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
      default: null,
    },
    categoryId: {
      type: Number,
      default: null,
    },
    material: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      MATERIAL_VIDEO_TYPES,
      selectedCategory: null,
      order: null,
      name: '',
      date: null,
      content: '',
      videoType: null,
      videoSrc: null,
      videoImg: null,
      videoImgFile: null,
      videoId: null,
      videoDuration: null,

      dateLocale: 'en-US',
      invalidFields: {},
    };
  },
  computed: {
    isTextContentCategoryType() {
      return this.selectedCategory
            && CATEGORIES_CONTENT_TYPE_TEXT.indexOf(this.selectedCategory.type) > -1;
    },
    isVideoContentCategoryType() {
      return this.selectedCategory
          && CATEGORIES_CONTENT_TYPE_VIDEO.indexOf(this.selectedCategory.type) > -1;
    },
    isVideoYouTubeType() {
      return this.isVideoContentCategoryType && this.videoType === MATERIAL_VIDEO_TYPE_YOUTUBE;
    },
    isVideoMP4Type() {
      return this.isVideoContentCategoryType && this.videoType === MATERIAL_VIDEO_TYPE_MP4;
    },
    dateFormattedValue() {
      if (!this.date) return '';
      const match = this.date.toString().match(/(\d{2})+\s(\d{4})+\s+(\d{2}:+\d{2}:+\d{2})/);
      const month = (`0${this.date.getMonth() + 1}`).slice(-2);
      return `${match[2]}-${month}-${match[1]}${match[3]}`;
    },
    currentImageSrc() {
      if (this.videoImgFile) return URL.createObjectURL(this.videoImgFile);
      if (this.videoImg && this.material.lastEditDate) {
        return `${this.videoImg}?tms=${(new Date(this.material.lastEditDate)).getTime()}`;
      }
      return '';
    },
  },
  created() {
    if (this.material) {
      this.order = this.material.order;
      this.name = this.material.name;
      this.date = new Date(this.material.date);
      this.content = this.material.content;
      this.videoType = this.material.videoType;
      this.videoSrc = this.material.videoSrc;
      this.videoImg = this.material.videoImg;
      this.videoId = this.material.videoId;
      this.materialId = this.material.id;
      this.videoDuration = this.material.videoDuration ? this.material.videoDuration.replace(/\D/g, '') : null;
      this.categories.forEach((item) => {
        if (item.id === this.material.categoryId) {
          this.selectedCategory = item;
        }
      });
    } else if (this.categoryId) {
      this.categories.forEach((item) => {
        if (item.id === this.categoryId) {
          this.selectedCategory = item;
        }
      });
    }
  },
  mounted() {
    if (this.order && this.$refs.orderInput) {
      this.$refs.orderInput.newValue = this.order;
    }
    if (this.videoDuration && this.$refs.videoDurationInput) {
      this.$refs.videoDurationInput.newValue = this.videoDuration;
    }
  },
  methods: {
    setInvalidFields(invalidFields) {
      this.invalidFields = invalidFields;
    },
    formIsValid() {
      const invalidFields = {};

      if (!/\S/.test(this.name)) invalidFields.name = 'This field is required.';

      if (!this.isTextContentCategoryType && !this.isVideoContentCategoryType) {
        invalidFields.categoryId = 'This field is required.';
      }

      if (this.isTextContentCategoryType && !/\S/.test(this.content)) {
        invalidFields.content = 'This field is required.';
      }

      if (this.isVideoContentCategoryType) {
        if (!this.videoDuration) invalidFields.videoDuration = 'This field is required.';
        if (this.isVideoYouTubeType) {
          if (!this.videoId) invalidFields.videoId = 'This field is required.';
        } else if (this.isVideoMP4Type) {
          if (!this.videoSrc) invalidFields.videoSrc = 'This field is required.';

          if (this.videoImgFile) {
            if (this.videoImgFile.size > 1e+6) {
              invalidFields.videoImgFile = 'The uploading file cannot be more than 1MB';
            }
            if (['image/jpeg', 'image/png', 'image/gif'].indexOf(this.videoImgFile.type) === -1) {
              invalidFields.videoImgFile = 'Please upload file in PNG, GIF, or JPG format';
            }
          } else if (!this.videoImg) {
            invalidFields.videoImgFile = 'This field is required.';
          }
        } else {
          invalidFields.videoType = 'This field is required.';
        }
      }

      this.invalidFields = invalidFields;
      return !Object.keys(invalidFields).length;
    },
    submit() {
      if (!this.formIsValid()) return;
      const formData = new FormData();
      if (this.videoImgFile) {
        formData.append('videoImgFile', this.videoImgFile);
      }
      formData.set('categoryId', this.selectedCategory.id ? this.selectedCategory.id : '');
      formData.set('order', this.order ? this.order : '');
      formData.set('name', this.name ? this.name : '');
      formData.set('date', this.dateFormattedValue ? this.dateFormattedValue : '');
      formData.set('content', this.content ? this.content : '');
      formData.set('videoType', this.videoType ? this.videoType : '');
      formData.set('videoSrc', this.videoSrc ? this.videoSrc : '');
      formData.set('videoId', this.videoId ? this.videoId : '');
      formData.set('videoDuration', this.videoDuration ? this.videoDuration : '');

      this.$emit('submit', formData, this.materialId);
    },
    cancel() {
      this.$emit('close');
    },
    onOrderInput(value) {
      const order = value.replace(/\D|^0$/g, '');
      this.order = order;
      this.$refs.orderInput.newValue = order;
    },
    onVideoDurationInput(value) {
      const duration = value.replace(/\D|^0$/g, '');
      this.videoDuration = duration;
      this.$refs.videoDurationInput.newValue = duration;
    },
    showDatetimepicker() {
      const Component = Vue.extend(DatetimepickerModal);
      const modal = new Component({
        propsData: {
          active: true,
          date: this.date,
        },
      });
      modal.$store = this.$store;
      modal.$mount();
      modal.$on('submit', (date) => {
        this.date = date;
        modal.active = false;
        this.$refs.self.$el.removeChild(modal.$el);
        setTimeout(this.$refs.self.handleScroll, 151);
      });
      modal.$on('close', () => {
        modal.active = false;
        this.$refs.self.$el.removeChild(modal.$el);
        setTimeout(this.$refs.self.handleScroll, 151);
      });
      this.$refs.self.$el.appendChild(modal.$el);
      this.addCategoryModal = modal;
    },
  },
};
</script>

<style scoped lang="stylus">
.dialog .modal-card .modal-card-body
  margin-top 0
.mpc
  >>> .animation-content
    max-width none !important
    width 600px
    .modal-close
      display none
      &.active
        display block
    @media(max-width:650px)
      width calc(100% - 10px)
  .copy-code
    width 100%
    margin 20px 0 25px
  .modal-card
    max-width 100%
    max-height 75vh
    height fit-content
    border-radius 6px
    &-title
      text-align left
  .modal-card-body
    padding 0 20px
    p
      text-align center
    &-subtitle
      text-align left
      margin-bottom 10px
  .modal-close
    top 50%
    transform translateY(-50%)
    border none
  .textarea
    word-break break-all
  .instruction
    margin-bottom 20px
    ol
      list-style none
      margin-bottom 20px
    b
      display block
      margin-bottom 5px
 .modal-close
   background none
   right 20px
.modal-card-foot
  .button
    width 80px
</style>
